import { AxiosError } from 'axios';

import httpInstances from '@/api/axiosInstance';
import { FORWARD_CURVE_FIELDS, SPOT_FIELDS } from '@/features/Catalog/constants/fieldNames';
import type { CatalogItem } from '@/types/catalog';

const extendCatalogWithSymbol = (items: CatalogItem[]): CatalogItem[] => {
  return items.map((catalogItem: CatalogItem) => ({
    ...catalogItem,
    Symbol: {
      Code: catalogItem.Code,
      Period: String(catalogItem.Period),
      PeriodType: catalogItem.PeriodType,
      TimeRef: catalogItem.TimeRef
    }
  }));
};

const handleCatalogError = (error: unknown): never => {
  if (error instanceof AxiosError && error.response) {
    const errorResponse = error.response.data as { message?: string };
    throw new Error(errorResponse.message || 'Request failed', { cause: error });
  }

  throw error;
};

export const catalogApi = {
  getSpotCatalog: async (): Promise<CatalogItem[]> => {
    try {
      const { data } = await httpInstances.axiosDataInstance.get(
        '/catalogue/spot?status=Live,Archive',
        {
          headers: {
            fields: [...SPOT_FIELDS]
          }
        }
      );

      return extendCatalogWithSymbol(data as CatalogItem[]);
    } catch (error) {
      return handleCatalogError(error);
    }
  },

  getForwardCatalog: async (): Promise<CatalogItem[]> => {
    try {
      const { data } = await httpInstances.axiosDataInstance.get(
        '/catalogue/curve?status=Live,Archive',
        {
          headers: {
            fields: [...FORWARD_CURVE_FIELDS]
          }
        }
      );

      return extendCatalogWithSymbol(data as CatalogItem[]);
    } catch (error) {
      return handleCatalogError(error);
    }
  }
};
